import { createStyles, makeStyles } from "@material-ui/core";
import {
  green600,
  green700,
  blue900,
  darkBlue800,
  red500,
  red600,
  white,
  gray50,
  gray400,
  red700,
} from "../constants";

export const useStyles = makeStyles(() =>
  createStyles({
    success: {
      backgroundColor: green600,
      color: "#fff",
      "&:hover": {
        backgroundColor: green700,
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 8,
    },
    outline: {
      backgroundColor: white,
      color: "#334155",
      border: `1px solid ${gray400}`,
      "&:hover": {
        backgroundColor: gray50,
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 8,
    },
    neutral: {
      backgroundColor: blue900,
      color: "#fff",
      "&:hover": {
        backgroundColor: darkBlue800,
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 8,
    },
    error: {
      backgroundColor: red500,
      color: "#fff",
      "&:hover": {
        backgroundColor: red600,
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 8,
    },
    outlineError: {
      backgroundColor: "rgba(220, 38, 38, 0.08)",
      color: red700,
      border: "1px solid rgba(220, 38, 38, 0.45)",
      "&:hover": {
        backgroundColor: "rgba(220, 38, 38, 0.16)",
        border: "1px solid rgba(220, 38, 38, 0.65)",
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 8,
    },
    gray: {
      backgroundColor: "#F3F4F6",
      color: "#000",
      "&:hover": {
        backgroundColor: "#E5E7EB",
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: 8,
    },
    gradient: {
      background:
        "linear-gradient(90deg, rgba(12, 223, 212, 0.14) 0%, rgba(40, 232, 105, 0.14) 100%)",
      color: "#003350",
      "&:hover": {
        background:
          "linear-gradient(90deg, rgba(12, 223, 212, 0.20) 0%, rgba(40, 232, 105, 0.20) 100%)",
      },
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: "none",
      borderRadius: "14px",
      border: "2px solid #2BE65E",
      width: "100%",
      fontSize: "18px",
      height: "32px",
    },
  })
);
